import { supabase } from './supabase';
import { addHistoryCore, listHistoryCore } from '@gv/core';

export type HistoryInsert = {
    contact_id: string;
    actor_id?: string | null;
    action: string;
    details?: Record<string, unknown>;
};

export async function addHistory(entry: HistoryInsert) {
    return addHistoryCore(supabase, entry);
}

export async function getHistory(contactId: string, limit = 50) {
    return listHistoryCore(supabase, contactId, limit);
}
